<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          COST CONSUMER
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            Cost Consumer Details
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon title="refresh" @click="getDetail()">
              refresh
            </v-icon>
          </v-flex>
        </v-card-title>
        <v-flex xs12 class="pa-7">
          <v-layout row wrap>
            <table width="80%">
              <tr>
                <td width="20%">Nature Activity</td>
                <td width="5%">:</td>
                <td width="60%" class="grey--text">
                  {{ costConsumer.nature_activity }}
                </td>
              </tr>
              <tr>
                <td>Category</td>
                <td>:</td>
                <td class="grey--text">
                  {{ costConsumer.category ? costConsumer.category : '-' }}
                </td>
              </tr>
              <tr>
                <td>Code Cost Center</td>
                <td>:</td>
                <td class="grey--text">
                  {{
                    costConsumer.code_cost_center
                      ? costConsumer.code_cost_center
                      : '-'
                  }}
                </td>
              </tr>
              <tr>
                <td>Cost Center Desc</td>
                <td>:</td>
                <td class="grey--text">
                  {{
                    costConsumer.costCenter ? costConsumer.costCenter.desc : '-'
                  }}
                </td>
              </tr>
            </table>
          </v-layout>
        </v-flex>
        <v-card-actions class="text-right">
          <v-spacer></v-spacer>
          <v-flex xs2 right class="mr-4 mb-4">
            <v-btn
              id="btn-cancel"
              dark
              rounded
              color="red"
              block
              :to="{ name: 'costConsumer' }"
            >
              Back
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import ProgressDialog from '../../../components/progress_dialog';

export default {
  $_veeValidate: {
    validator: 'new'
  },
  props: ['id'],
  components: { 'progress-dialog': ProgressDialog },
  data() {
    return {
      name: '',
      loading: true,
      progressDialogLoading: true,
      search: '',
      breadcrumbs: [
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Cost Consumer List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text: 'Cost Consumer Details',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      costConsumer: {}
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.$store
        .dispatch('costConsumer/detail', this.id)
        .then(data => {
          if (data.code === 200) {
            this.costConsumer = data.data.result;

            this.progressDialogLoading = false;
            this.loading = false;
          } else {
            this.progressDialogLoading = false;
            this.loading = false;
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    }
  }
};
</script>
